"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var link_1 = __importDefault(require("../../link"));
var styles_1 = __importDefault(require("./styles"));
var Menu = function (props) {
    var list = props.list, textColor = props.textColor;
    var classes = styles_1["default"]();
    return (react_1["default"].createElement(react_1["default"].Fragment, null, list.map(function (l, i) {
        return (react_1["default"].createElement(link_1["default"], { key: i, to: l.link },
            react_1["default"].createElement(IconButton_1["default"], { className: classes.iconButton, style: textColor ? { color: textColor } : undefined },
                react_1["default"].createElement(l.Icon, null))));
    })));
};
exports["default"] = Menu;
